import type { TokenData } from '@contexts/auth-provider/AuthProvider.types';

import {
  ANONYMOUS_CONTEXT,
  type LDUserContext,
} from './LaunchDarklyProvider.types';

/**
 * Builds a LaunchDarkly user context from AuthProvider's TokenData.
 * Returns anonymous context when no user is authenticated.
 *
 * Optionally includes module name and customerId (Manage module only).
 */
export function buildLDUserContext(
  authData: TokenData | null,
  moduleName?: string,
  customerId?: string
): LDUserContext {
  if (!authData) {
    return ANONYMOUS_CONTEXT;
  }

  return {
    kind: 'user',
    key: authData.email,
    name: `${authData.firstName} ${authData.lastName}`.trim(),
    email: authData.email,
    ...(moduleName && { module: moduleName }),
    ...(moduleName === 'Manage' && customerId && { customerId }),
  };
}
